import { render, staticRenderFns } from "./ModgroupModifierCreate.vue?vue&type=template&id=1cad0c2f&scoped=true"
import script from "./ModgroupModifierCreate.vue?vue&type=script&lang=ts"
export * from "./ModgroupModifierCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cad0c2f",
  null
  
)

export default component.exports